import React from 'react'

import { Link } from 'react-router-dom'

class Chat extends React.Component {
  constructor(props) {
    super(props)

    let hasBeenSeen = false
    let seenBy = undefined

    if (this.props.chat.seenBy !== undefined) {
      seenBy = this.props.chat.seenBy
      seenBy = seenBy.filter(item => item === this.props.aid)
    }

    if (seenBy === undefined || seenBy.length === 0) {
      // hasBeenSeen is already false
    } else if (seenBy.length > 0) {
      // Mark the status as seen here in React
      hasBeenSeen = true
    }

    this.state = {
      seen: hasBeenSeen
    }
  }

  markSeen() {
    this.setState((state, props) => ({
      seen: true
    }))
  }

  componentDidMount() {
    const classInstance = this

    // After 4 seconds, change the new status to seen
    if (this.props.linkToConversation === false) {
      setTimeout(
        function() {
          classInstance.markSeen()
        },
        4000,
        classInstance
      )
    }
  }

  render() {
    const { seen } = this.state

    let chatClassNames = 'conversation__item'
    let unseenMessagesCounter = ''
    let avatar = ''

    if (this.props.chat.accountId === this.props.aid) {
      chatClassNames = chatClassNames + ' user'
    }
    if (seen !== true) {
      chatClassNames = chatClassNames + ' new'
    }

    if (
      this.props.linkToConversation === true &&
      this.props.unseenMessagesCount !== undefined &&
      this.props.unseenMessagesCount > 0
    ) {
      let unseenMessagesCount = this.props.unseenMessagesCount
      if (this.props.unseenMessagesCount > 99) {
        unseenMessagesCount = '99+'
      }
      unseenMessagesCounter = (
        <span className="unseen-messages-counter">{unseenMessagesCount}</span>
      )
    }

    return (
      <li className={chatClassNames}>
        {this.props.linkToConversation === true ? (
          <Link
            className="chat__link--avatar"
            to={'messages/conversations/' + this.props.chat.conversationId}
          >
            {this.props.sender} {unseenMessagesCounter}
          </Link>
        ) : (
          <span>{this.props.sender}</span>
        )}
        <div className="chat">
          <p className="chat__message">{this.props.chat.message}</p>
          <span className="chat__time">
            {new Date(this.props.chat.dateCreated).toLocaleString()}
          </span>
          {this.props.linkToConversation === true ? (
            <Link
              className="chat__link"
              to={'messages/conversations/' + this.props.chat.conversationId}
            >
              Read More
            </Link>
          ) : (
            ''
          )}
        </div>
      </li>
    )
  }
}

export default Chat



// WEBPACK FOOTER //
// ./src/Components/Chat.js